import { Button, Screen, Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import s from "./NoAccess.module.css";

export interface NoAccessProps {
  onSignOut: () => void;
}

export function NoAccess({ onSignOut }: NoAccessProps) {
  const { t } = useTranslation("clinic");

  return (
    <Screen className={s.root}>
      <Text as="h1" size="xl" weight="bold">
        {t("noAccess.heading", "No access")}
      </Text>
      <Text as="p" className={s.description}>
        {t(
          "noAccess.description",
          "You signed in successfully, but your account doesn't have access to the Ferrivia Clinic app. Contact an administrator to get access.",
        )}
      </Text>
      <Button variant="secondary" onClick={onSignOut}>
        {t("noAccess.signOut", "Sign out")}
      </Button>
    </Screen>
  );
}
